import UploadFileIcon from '@mui/icons-material/UploadFile';
import { Box, Button, Typography, type SxProps, type Theme } from '@mui/material';
import { useRef, useState, type ReactNode } from 'react';

export interface FileDropZoneProps {
  onFiles: (files: File[]) => void;
  accept?: string;
  multiple?: boolean;
  disabled?: boolean;
  buttonLabel?: string;
  hint?: ReactNode;
  className?: string;
  sx?: SxProps<Theme>;
}

/** Choose or drop files — the one picker behind every file field. */
export function FileDropZone({ onFiles, accept, multiple, disabled, buttonLabel, hint, className, sx }: FileDropZoneProps) {
  const input = useRef<HTMLInputElement>(null);
  const [over, setOver] = useState(false);
  const take = (list: FileList | null) => {
    const files = Array.from(list ?? []);
    if (files.length) onFiles(multiple ? files : files.slice(0, 1));
  };
  return (
    <Box className={className}
         onDragOver={(e) => { if (disabled) return; e.preventDefault(); setOver(true); }}
         onDragLeave={() => setOver(false)}
         onDrop={(e) => { e.preventDefault(); setOver(false); if (!disabled) take(e.dataTransfer.files); }}
         sx={[{
           display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', px: 1.5, py: 1,
           border: '1px dashed', borderRadius: 1, transition: 'background-color 120ms',
           borderColor: over ? 'primary.main' : 'divider', bgcolor: over ? 'action.hover' : 'transparent',
           opacity: disabled ? 0.6 : 1,
         }, ...(Array.isArray(sx) ? sx : [sx])]}>
      <Button variant="outlined" size="small" startIcon={<UploadFileIcon />} disabled={disabled}
              onClick={() => input.current?.click()}>
        {buttonLabel ?? (multiple ? 'Choose files' : 'Choose file')}
      </Button>
      <Typography variant="caption" color="text.secondary">{hint ?? 'or drop here'}</Typography>
      <input ref={input} type="file" hidden accept={accept} multiple={multiple}
             onChange={(e) => { take(e.target.files); e.target.value = ''; }} />
    </Box>
  );
}
